import { useCallback } from "react";
import PasscodeForm from "../components/PasscodeForm";
import { useNavigate } from "react-router-dom";

const PassCode = () => {
  const navigate = useNavigate();

  const onButtonBarClick = useCallback(() => {
    navigate("/signup");
  }, [navigate]);

  const onTertiaryButtonBackTextClick = useCallback(() => {
    navigate("/signup");
  }, [navigate]);

  return (
    <div className="relative w-full h-[1024px] overflow-hidden flex flex-col pt-32 px-0 pb-0 box-border items-center justify-start gap-[32px] bg-[url(/public/passcode@3x.png)] bg-cover bg-no-repeat bg-[top] md:items-center md:justify-start sm:items-center sm:justify-start">
      <PasscodeForm />
      <button
        className="[border:none] py-[22px] px-8 bg-light rounded-31xl flex flex-row items-center justify-center gap-[10px] cursor-pointer"
        autoFocus
        disabled
        onClick={onButtonBarClick}
      >
        <b
          className="relative text-base font-footnote text-dark text-left cursor-pointer hover:text-darkslategray-300"
          onClick={onTertiaryButtonBackTextClick}
        >
          Back
        </b>
        <div className="relative rounded-[50%] bg-dark w-2 h-2" />
        <b className="relative text-base font-footnote text-dark text-left hover:text-darkslategray-300">
          Exit
        </b>
      </button>
    </div>
  );
};

export default PassCode;
